import EventSpecs from '@/common/api/definitions/event-specs';
import isNotEmpty from '@/common/helpers/is-not-empty';
import unKebabCase from '@/common/helpers/un-kebab-case';
import EntityModel from '@/common/models/entity-model';
import EventTypes from '@/common/api/definitions/event-types';

export default class EventModel extends EntityModel {
    static Types = EventTypes;

    // Cache the specs to static property,
    // events consumers should use this property
    // instead of importing module and generate the specs again.
    static Specs = EventSpecs;

    get hasRules() {
        return this.rulesCount > 0;
    }

    get hasBinds() {
        return this.bindsCount > 0;
    }

    get definition() {
        return EventModel.Specs[this.eventType];
    }

    get availableActions() {
        return this.definition.actions;
    }

    get pathways() {
        return this.definition.pathways;
    }

    get defaultEmailSenders() {
        return this.definition.defaultEmailSenders;
    }

    get defaultEmailReceivers() {
        return this.definition.defaultEmailReceivers;
    }

    get invoiceAttachmentPlaceholder() {
        return this.definition.attachableInvoiceId;
    }

    get canAttachInvoice() {
        return isNotEmpty(this.invoiceAttachmentPlaceholder);
    }

    get placeholderPathways() {
        return this.definition.placeholderGroups;
    }

    get links() {
        return this.definition.links;
    }

    get emailTemplates() {
        return this.definition.emailTemplates;
    }

    get hasEmailTemplates() {
        return this.emailTemplates.length > 0;
    }

    hydrate({
        eventType = null,
        title = null,
        description = null,
        rulesCount = null,
        bindsCount = null,
        emailBindsCount = null,
    } = {}) {
        if (!EventModel.Specs[eventType]) {
            throw new Error(`Undefined event type ${eventType}`);
        }

        this.eventType = eventType;
        this.title = title || unKebabCase(eventType);
        this.description = description || EventSpecs[eventType].description;
        this.rulesCount = rulesCount;
        this.bindsCount = bindsCount;
        this.emailBindsCount = emailBindsCount;
    }
}
